import React from 'react'

const Label = ({ text }: { text: string }): JSX.Element => <>{text}</>

export default Label
